(function () {
    'use strict';

    angular
        .module('app')
        .controller('GroupsListController', GroupsListController);

    GroupsListController.$inject = ['API', 'alert', 'debug', 'helpers', '$stateParams', 'ListViewSearchExtension', 'i18n',];

    function GroupsListController(API, alert, debug, helpers, $stateParams, ListViewSearchExtension, i18n) {
        var vm = this;
        ListViewSearchExtension.extendScope(vm);
        vm.listObject.filter = 'licenseExpiryDescending';
        vm.loadingState = {
            groupIsLoading: false
        };
        vm.openRemoveModal = openRemoveModal;

        vm.now = helpers.getDatabaseDatetime();
        vm.loadResources = loadResources;
        vm.keyUp = keyUp;
        vm.groups = [];

        activate();

        function activate() {
            if ($stateParams.searchObject) {
                vm.loadParams(JSON.parse($stateParams.searchObject));
            }
            loadResources(true);
        }

        function openRemoveModal(group) {
            var promise = alert.confirm('remove-item');

            promise.then(function() {
                var removePromise = API.Group.recycle({ id: group.id }).$promise;

                removePromise.then(function() {
                    var index = vm.groups.findIndex(function(item) {
                        return item.id === group.id;
                    });
                    vm.groups.splice(index, 1);
                    window.toast({ type: 'success', autoRemoveTime: 5000, message: i18n.get('GROUP_RECYCLED') });
                }, function() {});
            }, function() {});
        }

        function loadResources(skipCharacterLimit) {
            var promise = null;

            var searchObject = {
                'page': vm.listObject.page,
                'per-page': vm.listObject.perPage,
                'expand': 'school, users',
            };
            if (vm.listObject.filter) {
                switch (vm.listObject.filter) {
                    case 'alphabetAscending':
                        searchObject.sort = '-name';
                        break;
                    case 'alphabetDescending':
                        searchObject.sort = 'name';
                        break;
                    case 'licenseExpiryAsscending':
                        searchObject.sort = 'license_expiry';
                        break;
                    case 'licenseExpiryDescending':
                        searchObject.sort = '-license_expiry';
                        break;

                    default:
                        break;
                }
            }

            if (vm.listObject.searchTerm && (vm.listObject.searchTerm.length > 2 || skipCharacterLimit)) {
                searchObject.q = vm.listObject.searchTerm;
                promise = API.Group.search(searchObject).$promise;
            } else if (vm.listObject.searchTerm.length === 0) {
                promise = API.Group.search(searchObject).$promise;
            }

            vm.onSearch();

            if (promise) {
                vm.loadingState.groupIsLoading = true;
                promise.then(function (response) {
                    vm.groups = response.items;
                    vm.listMeta = response._meta;
                }, function (response) {
                    debug.log(response);
                })
                .finally(function() {
                    vm.loadingState.groupIsLoading = false;
                });
            }
        }

        function keyUp(event) {
            if (event.keyCode === 13) {
                vm.loadResources(true);
            }
        }
    }
})();